import React from "react";
import Select from "react-select";
import AddressInfo from "../addressInfo";
const CoveringZoneInfo = ({zones ,setZonesToCover ,setCuriorInfo ,zones_to_cover ,addressInfo,setAddressInfo ,area,setArea ,formErrors}) => {
    const  selectedZones= zones.filter((zone) =>
    zones_to_cover.includes(zone.id)
  );
  return (
    <div>
         {/* Address Component */}
      <AddressInfo addressInfo={addressInfo} setAddressInfo={setAddressInfo} area={area} setArea={setArea}  formErrors={formErrors}/>
      <div className="col-12 mt-3">
        <label htmlFor=""> المناطق المغطاه</label>
        <Select
          isMulti
          options={zones}
          value={selectedZones}
          onChange={(selected) =>
          setZonesToCover(selected.map((item) => item.id))
}
          getOptionLabel={(e) => e.name}
          getOptionValue={(e) => e.id}
        ></Select>
      </div>

      <h6 className="fw-bold mb-1 mt-2">الحالة</h6>
     <select className="form-select" onChange={(e)=>{
      setCuriorInfo((prev)=> ({
       ...prev,
        status:e.target.value
      })
    
      )
     }}> 

      <option value="active">نشط</option>
      <option value="inActive">غير نشط</option>
        <option value="blocked">محظور</option>
     </select>
    </div>
  );
};

export default CoveringZoneInfo;
